import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetPqrNotificationAreasHistory } from '../../../../../../services/pqr.service'; // Ajusta la ruta y función real
import { TableTooltip } from '../../../../../components/general/table';
import DateTimeFormat from '../../../../../components/dateTimeFormat';
import { PqrNotificationAreasHistoryProps } from './props';
import { PqrNotificationAreasHistory } from '../../../../../../shared/types/modules/pqr';

export const usePqrNotificationAlertHistory = ({
    pqrId,
}: PqrNotificationAreasHistoryProps) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<PqrNotificationAreasHistory[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<PqrNotificationAreasHistory>[] = [
        {
            field: 'id',
            headerName: 'Id Histórico',
            minWidth: 120,
            flex: 0.3,
            renderCell: (params) => <TableTooltip value={params.row.id} />,
        },
        {
            field: 'sent_at',
            headerName: 'Fecha Envío',
            minWidth: 150,
            flex: 0.4,
            renderCell: (params) => (
                <DateTimeFormat dateAt={params.row.sent_at} />
            ),
        },
        {
            field: 'user',
            headerName: 'Usuario',
            minWidth: 120,
            flex: 0.3,
            renderCell: (params) => (
                <TableTooltip value={params.row.user || ''} />
            ),
        },
        {
            field: 'recipients',
            headerName: 'Destinatarios',
            minWidth: 200,
            flex: 0.6,
            renderCell: (params) => {
                const recipients = Array.isArray(params.row.recipients)
                    ? params.row.recipients.join(', ')
                    : params.row.recipients || '';
                return <TableTooltip value={recipients} />;
            },
        },
        {
            field: 'pqrId',
            headerName: 'PQR Id',
            minWidth: 120,
            flex: 0.3,
            renderCell: (params) => <TableTooltip value={params.row.pqrId} />,
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 120,
            flex: 0.3,
            renderCell: (params) => (
                <TableTooltip value={params.row.status || ''} />
            ),
        },
    ];

    useEffect(() => {
        setLoading(true);
        asyncGetPqrNotificationAreasHistory(pqrId, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, pqrId]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
